import ROUTE_CONSTANTS from '@/src/constants/route-constants.js'
export default {
  routerList: ROUTE_CONSTANTS,
  featureName: [],
}
